<app-dashboard-layout [pageTitle]="'business.title' | translate" [hasAction]="false"
    (onNotificationClick)="onNotificationClicked()" (onAction)="onActionClicked()">
    <div pageContent pageContent class="w-full">
        <app-business-ui [business]="business" (updateRequested)="update()"></app-business-ui>
    </div>
</app-dashboard-layout>
